import { render, staticRenderFns } from "./UserPanel.vue?vue&type=template&id=2adbc35e&scoped=true&"
import script from "./UserPanel.vue?vue&type=script&lang=js&"
export * from "./UserPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2adbc35e",
  null
  
)

export default component.exports